import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="active-options"
export default class extends Controller {
  static targets = ['optionCard']

  connect() {
    this.toggleActive()
  }

  toggleActive() {
    this.optionCardTargets.forEach(element => {
      if (element.querySelector('input').checked) element.classList.add('active')
      else element.classList.remove('active')
    })
  }
}
